import { AllMessagesResponse, Message } from 'src/api/messagesApi';

export const getMessageDisplayName = (message: Message): string =>
  message.user_name || message.leader_name || '';

export const getMessageThumbnail = (message: Message): string =>
  message.thumbnail ||
  message.video?.thumbnail_url ||
  message.animated_gif ||
  message.video?.animated_gif_url ||
  '';

export const getMessageVideoUrl = (message: Message): string =>
  message.video_url || message.video?.url || '';

export const normalizeCircleMessages = (
  payload: Pick<AllMessagesResponse, 'result' | 'replies'>,
  isLeader: boolean
): Message[] => {
  const result = payload.result ?? [];
  const replies = payload.replies ?? [];
  const items: Message[] = [];
  const seen = new Set<string>();

  const push = (message?: Message | null) => {
    if (!message?._id || seen.has(message._id)) {
      return;
    }
    seen.add(message._id);
    items.push(message);
  };

  result.forEach((message) => {
    push(message);
    if (!isLeader) {
      push(message.response_data);
    }
  });

  if (isLeader) {
    replies.forEach(push);
  }

  return items.sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
};
